import React, {Component} from 'react'
import './header.css'
import Select from "react-select";
import Fr from './france.svg'
import En from './en.svg'
const options = [
    { value: "fr", label: <div><img src={Fr} style={{width:20}} alt="fr"/> {' '} FR </div>, icon: "france.svg" },
    { value: "en", label: <div><img src={En} style={{width:20}} alt="en"/> {' '} EN </div>, icon: "en.svg" }
  ];

  //const { Option } = components;
  /*const IconOption = props => (
    <Option {...props}>
      <img
        src={require('./' + props.data.icon)}
        style={{ width: 25 }}
        alt={props.data.label}
      />
      {props.data.label}
    </Option>
  );*/
class Header extends Component {
    change(option){
        localStorage.setItem('lang', option.value);
        //window.location.reload();
        console.log(option)
    }
  render() {
    //const lang = localStorage.getItem('lang') || 'en';
    return (
        <>
           <div  className='selec'>
              <Select
                  
                    onChange={this.change}
                    defaultValue={options[0]}
                    options={options}
                    /*components={{ Option: IconOption }}*/
                />
           </div>
        </>
    )
  }
}

export default Header;
